module.exports = __webpack_public_path__ + "img/18.e8ddd866.jpg";